<template>

    <ion-content class="block__login-forget">
      <section class="block__login-wrapper d-flex justify-content-center align-items-center">
        <b-overlay 
            :show="show"
            rounded="sm"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-small        
        >
          
          <b-card class="text-center">
            <b-img :src="content.src" class="logo" fluid alt="logo"></b-img>
            <p class="title">Réinitialisation du mot de passe</p>
            <form @submit.prevent="submit()">
              <div class="text-left">

                <b-form  @submit.stop.prevent>
                  <label for="feedback-user">Nouveau mot de passe</label>
                  <b-input type="password" model id="password" v-model="password" :class="{error:passwordError}"></b-input>
                </b-form>

                <b-form  @submit.stop.prevent>
                  <label for="feedback-user">Confirmation du mot de passe</label>
                  <b-input type="password" v-model="password_confirm" id="password_confirm" :class="{error:passwordError}"></b-input>
                </b-form>
              </div>
              <Stack></Stack>
              <div class="d-flex flex-column justify-content-center align-items-center flex-nowrap">
                <b-button v-on:click="resetPass()" class="bt bt__connected">Modifier le mot de passe</b-button>
              </div>

            </form>
          </b-card>
        </b-overlay>
      </section>


        <b-toast id="error-message" solid toaster="b-toaster-top-full" auto-hide-delay="8000" variant="danger">
          <template v-slot:toast-title>
            <strong class="mr-auto">{{content.error}}</strong>
          </template>
          {{error_desc}}
        </b-toast>

    </ion-content>


</template>


<script>
// import AreasStore from '../AreasStore'
import { mapGetters } from 'vuex'
import utils from '../Utils'
import Stack from '../module/stack/Stack'
import ApiService from '../../services/ApiService'


export default {

  // store:AreasStore,
    components:{
      Stack
    }, 
  data() {
    return {
      content:null,
      notActivated:true,
      error_desc: '',
      show: false,
      password:null,
      password_confirm:null,
      token:null,
      emailError:false,
      passwordError:false
    };
  },
    computed: {
    ...mapGetters([
      'getLogin',
    ])
  },
  created (){
    this.content = this.getLogin;
  },
  methods : {
    resetPass(){
      if(this.checkPassword() == true){
        let body = {
          'token': this.$route.query.token,
          'password': this.password,
          'password_conf':this.password_confirm
        }
        ApiService.getProfilApi().resetPassword(body).then(
            () => {
              this.makeToast('success');
              this.$router.push({name: "login"});
            },
            () => {
              this.makeToast('error');
            });
      } else {
        this.makeToast('error');
      }
    },
    makeToast(variant = null) {
      if(variant === 'success'){
        this.$bvToast.toast('Modification du mot de passe réalisée avec succes', {
          title: `Modification du mot de passe`,
          variant: variant,
          solid: true,
          toaster:'b-toaster-top-center'
        })
      } else {
        this.$bvToast.toast('Une erreur est survenu, les champs mot de passe sont invalides', {
          title: `Modification du mot de passe`,
          variant: variant,
          solid: true,
          toaster: 'b-toaster-top-center'
        })
      }
    },
    checkPassword(){
      if(this.password != null && this.password != '' && this.password == this.password_confirm){
        this.passwordError = false;
        return true;
      } else {
        this.passwordError = true;
        return false;
      }
    },
    goBack(){
      this.$router.push({name: "login"});
    },
    activeFormButton(){
      utils.validEmail(this.userId) ? this.notActivated = false : this.notActivated = true;
    },    
  },
  watch:{
    'userId' : function(){
      this.checkMail();
    },
  },  

};
</script>
